export default __webpack_public_path__ + "static/media/hht1_ep1_minisitcom_03.7571e8dc.png";